module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product9-bb8607f8606582de122069ffc3077dbd.jpg";